import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "more",
  "use": "more-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"more\"><path fill-rule=\"evenodd\" d=\"M5 16a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0-5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0-5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol